import { ApiRequest } from "api/makeApiRequest/ApiRequest";

export function addPostProcessingToResponse<T, U, V>(
	req: ApiRequest<T>,
	postProcess: (arg: T | undefined, requestPayload: V) => U,
	requestPayload: V
) {
	return {
		ready: req.ready.then(result => postProcess(result, requestPayload)),
		abort: () => req.abort(),
		aborted: () => req.aborted(),
		type: req.type
	};
}
